import { SVGProps } from "react";

export const Info = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#clip0_1_9133)"
      >
        <path d="M12 21a9 9 0 100-18 9 9 0 000 18zM12 8v4M12 16h.01"></path>
      </g>
      <defs>
        <clipPath id="clip0_1_9133">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
